
// ======================================================================
// 📁 File: src/modules/service_crm/ServiceCRMLayout.js
// 📝 Purpose:
//   Main layout wrapper for Service CRM module
//   - Includes sidebar
//   - Handles content spacing
//   - Follows PPE layout architecture
// ======================================================================

import React, { useState } from "react";
import ServiceCRMSidebar from "./layout/ServiceCRMSidebar";

export default function ServiceCRMLayout({ children }) {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f3f4f6",
      }}
    >
      {/* Sidebar */}
      <ServiceCRMSidebar
        onToggle={(expanded) => setSidebarExpanded(expanded)}
      />

      {/* Main Content */}
      <main
        style={{
          marginLeft: sidebarExpanded ? 260 : 64,
          transition: "margin-left 0.22s ease",
          padding: 20,
        }}
      >
        {children}
      </main>
    </div>
  );
}